import api from './api';

export const createBooking = async (bookingData) => {
    try {
        const response = await api.post('/api/bookings', bookingData);
        return response.data;
    } catch (error) {
        console.error('Error creating booking:', error);
        throw error;
    }
};



